import {useAgendaCategoryCustom} from '@/features/agenda/hooks/useAgendaCategoryCustom'
import {useAgendaCategoryPatientAgeRange} from '@/features/agenda/hooks/useAgendaCategoryPatientAgeRange'
import {useAgendaCategoryTeam} from '@/features/agenda/hooks/useAgendaCategoryTeam'
import {useAgendaNavigation} from '@/features/agenda/hooks/useAgendaNavigation'
import {useAgendaSearchParams} from '@/features/agenda/hooks/useAgendaSearchParams'
import {PatientSmall} from '@/features/patients/types'
import {UserSmall} from '@/features/users/types'

type AgendaSubjectsReturn<T extends 'users' | 'patients'> = {
    isLoading: boolean
    subjects: T extends 'patients' ? PatientSmall[] : UserSmall[]
    patient?: PatientSmall
}

export const useAgendaSubjects = <T extends 'users' | 'patients'>(): AgendaSubjectsReturn<T> => {
    const {
        params: {entity}
    } = useAgendaNavigation()
    const {isTeamCategory, isPatientAgeRangeCategory} = useAgendaSearchParams()

    const {team, patient, isLoading: isLoadingTeam} = useAgendaCategoryTeam()
    const {users, isLoading: isLoadingPatientAgeRange} = useAgendaCategoryPatientAgeRange()
    const {subjects, isLoading: isLoadingSubjects} = useAgendaCategoryCustom<typeof entity>()

    const isLoading = isLoadingTeam || isLoadingPatientAgeRange || isLoadingSubjects

    return {
        isLoading,
        patient,
        subjects: (subjects.length > 0
            ? subjects
            : isTeamCategory
              ? team
              : isPatientAgeRangeCategory
                ? users
                : []) as T extends 'patients' ? PatientSmall[] : UserSmall[]
    }
}
